function RelatedArticlesKrigingAndTerraStation() {
  return (
    <div
      id="ts-relatedarticles-wrapper"
      className="w-full h-full flex items-center justify-center"
    >
      <div
        id="ts-relatedarticles-content"
        className="w-2/3 p-4 h-full flex flex-col items-center"
      >
        <div className="w-full relative flex items-center justify-center text-2xl p-2 border-b border-light-border">
          Kriging and TerraStation
        </div>

        <div className="w-full bg-gray-50 text-light-text p-6 mt-6 rounded-lg shadow-sm space-y-4">
          <p>
            Semivariogram modelling and 2D kriging are available in the TerraStation Mapping Module.
          </p>
          <p>
            These options are located in Z Analysis of the Map Module. A variogram model must be built before performing 2D kriging.
            The display and building of variogram models are done in Variogram Displays in Z Analysis.
          </p>
          <p>
            The program features eight available measures of spatial continuity in up to 8 directions:
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>Semivariogram (can be modeled)</li>
            <li>Covariance</li>
            <li>Correlogram</li>
            <li>General relative semivariogram</li>
            <li>Pairwise relative semivariogram</li>
            <li>Semivariogram of logarithms</li>
            <li>Semirodogram</li>
            <li>Semimadogram</li>
          </ul>
          <p>
            Semivariograms may be based on Spherical, Exponential, Gaussian, or Power functions, and the user can control a number of other variogram parameters,
            including the nugget, sill, azimuth, anisotropy angle and factor.
          </p>
          <p>
            After you have built your semivariogram model, you are ready to krige your data. TerraStation provides you with five types of kriging:
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>Ordinary</li>
            <li>External Drift</li>
            <li>Two types of polynomial trend kriging</li>
            <li>Simple</li>
          </ul>
          <p>
            Kriging estimates may be calculated for grid nodes (point kriging) or grid cell averages (block kriging). Output grid values may be filtered,
            and a grid of estimation standard errors may also be produced.
          </p>
          <p>
            Kriging techniques are a powerful means of using statistical methods to compensate for local trends in contouring your data, resulting in more accurate maps with known error ranges.
            We hope you will find this a useful addition to your toolkit.
            As always, your comments and suggestions are valued by us and will be incorporated to make the system even better.
          </p>
          <p>
            Two good references which can help you learn more about geostatistical methods are:
          </p>
          <div className="space-y-1">
            <p>
              Deutsch, Clayton V. and Journel, Andre G.<br />
              GSLIB: Geostatistical Software Library and User's Guide<br />
              Oxford University Press, New York, NY, 1992
            </p>
            <p>
              Isaaks, Edward H. and Srivastava, R. Mohan<br />
              An Introduction to Applied Geostatistics<br />
              Oxford University Press, New York, NY, 1989
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RelatedArticlesKrigingAndTerraStation;
